import { forwardRef, type SelectHTMLAttributes } from 'react';
import { ChevronDown } from 'lucide-react';
import { cn } from '@/lib/cn';

type SelectProps = SelectHTMLAttributes<HTMLSelectElement> & {
  invalid?: boolean;
};

export const Select = forwardRef<HTMLSelectElement, SelectProps>(function Select(
  { className, invalid, children, ...rest },
  ref,
) {
  return (
    <div className="relative">
      <select
        ref={ref}
        className={cn(
          'h-10 w-full appearance-none rounded-md border bg-white px-3 pr-9 text-sm text-neutral-ink',
          'transition focus:outline-none focus:ring-2 focus:ring-blue-30',
          invalid
            ? 'border-orange focus:border-orange focus:ring-orange/30'
            : 'border-surface-line focus:border-blue',
          'disabled:opacity-60',
          className,
        )}
        {...rest}
      >
        {children}
      </select>
      <ChevronDown
        size={14}
        className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 text-neutral-muted"
      />
    </div>
  );
});
